import { useQuery } from "@tanstack/react-query"
import { websiteProductService } from "@/api/websiteProductService"

export const useSimilarProducts = (sku: string) => {
  return useQuery({
    queryKey: ["website-product-similar", sku],
    queryFn: ({ signal }) =>
      websiteProductService.getSimilarProducts(sku, signal),
    enabled: !!sku,
  })
}
